export const GET_COACHING_SESSION_REQUESTING =
  "coaching/GET_COACHING_SESSION_REQUESTING";
export const GET_COACHING_SESSION_SUCCESS =
  "coaching/GET_COACHING_SESSION_SUCCESS";
export const GET_COACHING_SESSION_ERROR = "coaching/GET_COACHING_SESSION_ERROR";

export const UPDATE_COACHING_SESSION_REQUESTING =
  "coaching/UPDATE_COACHING_SESSION_REQUESTING";
export const UPDATE_COACHING_SESSION_SUCCESS =
  "coaching/UPDATE_COACHING_SESSION_SUCCESS";
export const UPDATE_COACHING_SESSION_ERROR =
  "coaching/UPDATE_COACHING_SESSION_ERROR";

export const CREATE_COACHING_SESSION_REQUESTING =
  "coaching/CREATE_COACHING_SESSION_REQUESTING";
export const CREATE_COACHING_SESSION_SUCCESS =
  "coaching/CREATE_COACHING_SESSION_SUCCESS";
export const CREATE_COACHING_SESSION_ERROR =
  "coaching/CREATE_COACHING_SESSION_ERROR";

export const GET_ACTIVE_COACHING_SESSION_REQUESTING =
  "coaching/GET_ACTIVE_COACHING_SESSION_REQUESTING";
export const GET_ACTIVE_COACHING_SESSION_SUCCESS =
  "coaching/GET_ACTIVE_COACHING_SESSION_SUCCESS";
export const GET_ACTIVE_COACHING_SESSION_ERROR =
  "coaching/GET_ACTIVE_COACHING_SESSION_ERROR";

export const GET_COACHING_RESOURCES_REQUESTING =
  "coaching/GET_GET_COACHING_RESOURCES_REQUESTING";
export const GET_COACHING_RESOURCES_SUCCESS =
  "coaching/GET_GET_COACHING_RESOURCES_SUCCESS";
export const GET_COACHING_RESOURCES_ERROR =
  "coaching/GET_GET_COACHING_RESOURCES_ERROR";

export const VISIT_RESOURCE_REQUESTING = "coaching/VISIT_RESOURCE_REQUESTING";
export const VISIT_RESOURCE_SUCCESS = "coaching/VISIT_RESOURCE_SUCCESS";
export const VISIT_RESOURCE_ERROR = "coaching/VISIT_RESOURCE_ERROR";

export const SUBMIT_RESOURCE_FEEDBACK_REQUESTING =
  "coaching/SUBMIT_RESOURCE_FEEDBACK_REQUESTING";
export const SUBMIT_RESOURCE_FEEDBACK_SUCCESS =
  "coaching/SUBMIT_RESOURCE_FEEDBACK_SUCCESS";
export const SUBMIT_RESOURCE_FEEDBACK_ERROR =
  "coaching/SUBMIT_RESOURCE_FEEDBACK_ERROR";

export const CREATE_COACHING_FILE_SUCCESS =
  "upload/CREATE_COACHING_FILE_SUCCESS";
export const CREATE_COACHING_FILE_ERROR = "upload/CREATE_COACHING_FILE_ERROR";
export const CREATE_COACHING_FILE_REQUESTING =
  "upload/CREATE_COACHING_FILE_REQUESTING";
